// 상단 네비게이션 바 — poc-portal TopNav 이식판 (react-router → lib/navigation 훅으로 교체)
import React, { useEffect, useRef, useState } from 'react';
import { usePathname, navigate } from '../../lib/navigation';
import { usePortal, setPortal } from '../../lib/portal';
import { useT } from '../../lib/locale';
import { MessageKey } from '../../lib/locale.messages';
import { useAuth } from '../../context/AuthContext';
import { AXAvatar } from 'yukimushi-component-fe';
import LanguageSwitcher from './LanguageSwitcher';
import styles from './TopNav.module.css';

/* 아바타 등 public 에셋 경로 접두사 (프로덕션 하위 경로 배포 대응) */
const PUBLIC_URL = process.env.PUBLIC_URL || '';

/* ── 탭 정의 ── */
interface TabDef {
  id: string;
  /** 표시 이름 — 번역 키 (lib/locale.messages.ts) */
  labelKey: MessageKey;
  path: string;
  icon: React.ReactNode;
}

const TAB_DEFS: TabDef[] = [
  {
    id: 'home',
    labelKey: 'nav.home',
    path: '/',
    icon: (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
      </svg>
    ),
  },
  {
    id: 'mail',
    labelKey: 'nav.mail',
    path: '/mail',
    icon: (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/>
        <path d="M22 6l-10 7L2 6"/>
      </svg>
    ),
  },
  {
    id: 'messenger',
    labelKey: 'nav.messenger',
    path: '/messenger',
    icon: (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
    ),
  },
  {
    id: 'board',
    labelKey: 'nav.board',
    path: '/board',
    icon: (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 6h16M4 10h16M4 14h10"/>
      </svg>
    ),
  },
  {
    id: 'oneffice',
    labelKey: 'nav.oneffice',
    path: '/oneffice',
    icon: (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
      </svg>
    ),
  },
  {
    id: 'videoconf',
    labelKey: 'nav.videoconf',
    path: '/videoconf',
    icon: (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M15 10l4.553-2.069A1 1 0 0 1 21 8.82v6.36a1 1 0 0 1-1.447.89L15 14M3 8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
      </svg>
    ),
  },
  {
    id: 'onechamber',
    labelKey: 'nav.onechamber',
    path: '/onechamber',
    icon: (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2"/>
        <path d="M3 9h18M9 21V9"/>
      </svg>
    ),
  },
  {
    id: 'finance',
    labelKey: 'nav.finance',
    path: '/finance',
    icon: (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 3v18h18"/>
        <path d="M7 15l4-4 3 3 5-6"/>
      </svg>
    ),
  },
  {
    id: 'basicinfo',
    labelKey: 'nav.basicinfo',
    path: '/basicinfo',
    icon: (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <ellipse cx="12" cy="5" rx="8" ry="3"/>
        <path d="M4 5v14c0 1.66 3.58 3 8 3s8-1.34 8-3V5"/>
        <path d="M4 12c0 1.66 3.58 3 8 3s8-1.34 8-3"/>
      </svg>
    ),
  },
  {
    id: 'pjt',
    labelKey: 'nav.pjt',
    path: '/pjt',
    icon: (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="16" rx="2"/>
        <path d="M8 2v4M16 2v4M3 10h18M8 14h3M8 17h6"/>
      </svg>
    ),
  },
  {
    id: 'hr',
    labelKey: 'nav.hr',
    path: '/hr',
    icon: (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
  },
  {
    id: 'erp-voucher',
    labelKey: 'nav.erpMain',
    path: '/erp',
    icon: (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="2" width="16" height="20" rx="2"/>
        <path d="M8 6h8M16 14v4M16 10h.01M12 10h.01M8 10h.01M12 14h.01M8 14h.01M12 18h.01M8 18h.01"/>
      </svg>
    ),
  },
];

/* ── AI 대화 탭 타입 ── */
interface AiChatTab {
  id: string;
  num: number;
}

/* ── 경로 → 탭 ID ── */
function getTabId(pathname: string): string {
  if (pathname.startsWith('/mail')) return 'mail';
  if (pathname.startsWith('/messenger')) return 'messenger';
  if (pathname.startsWith('/board')) return 'board';
  if (pathname.startsWith('/oneffice')) return 'oneffice';
  if (pathname.startsWith('/videoconf')) return 'videoconf';
  if (pathname.startsWith('/onechamber')) return 'onechamber';
  if (pathname.startsWith('/finance')) return 'finance';
  if (pathname.startsWith('/basicinfo')) return 'basicinfo';
  if (pathname.startsWith('/pjt')) return 'pjt';
  if (pathname.startsWith('/hr')) return 'hr';
  if (pathname.startsWith('/erp')) return 'erp-voucher';
  return 'home';
}

/* ── 탭 ID → 경로 ── */
function getTabPath(id: string): string {
  return TAB_DEFS.find(t => t.id === id)?.path ?? '/';
}

export default function TopNav() {
  const pathname = usePathname();
  const { user, logout } = useAuth();
  const portal = usePortal();
  const { t } = useT();
  const portalLabel = t(portal === 'zeirishi' ? 'top.portalZeirishi' : 'top.portalDefault');
  const [openTabs, setOpenTabs] = useState<string[]>(['home']);
  const [activeTab, setActiveTab] = useState<string>('home');

  /* 프로필 드롭다운 메뉴 */
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!menuOpen) return;
    const onClick = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [menuOpen]);

  const handleLogout = async () => {
    setMenuOpen(false);
    await logout();
    // 인증 상태가 풀리면 App이 로그인 화면으로 전환 — 경로만 초기화
    navigate('/', { replace: true });
  };

  const displayName = user?.name ?? '김민준';
  const displayPosition = user?.position || 'Enterprise AI Platform';

  /* AI 대화 탭 */
  const [aiChatTabs, setAiChatTabs] = useState<AiChatTab[]>([]);
  const [activeAiTabId, setActiveAiTabId] = useState<string | null>(null);
  const aiChatCounterRef = useRef(0);
  /* 다른 모듈 탭으로 이동해도 "실제로 Home에 살아있는 AI 채팅"을 계속 추적하기 위한 ref.
     activeAiTabId는 탭 하이라이트(시각 상태)용이라 모듈 이동 시 null로 초기화되지만,
     이 ref는 그대로 유지되어 이후 AI 탭 재클릭 시 올바른 prevChatId를 넘길 수 있게 한다. */
  const lastAiChatIdRef = useRef<string | null>(null);

  /* 경로 변경 → 탭 자동 추가 & 활성화 */
  useEffect(() => {
    const tabId = getTabId(pathname);
    if (tabId !== 'home') {
      setOpenTabs(prev => (prev.includes(tabId) ? prev : [...prev, tabId]));
      setActiveAiTabId(null); // 다른 페이지 이동 시 AI 탭 비활성
    }
    setActiveTab(tabId);
  }, [pathname]);

  /* navNewAiChat 이벤트: 새 AI 대화 탭 추가 */
  useEffect(() => {
    const handler = (e: Event) => {
      const ce = e as CustomEvent<{ chatId: string }>;
      const num = ++aiChatCounterRef.current;
      const newTab: AiChatTab = { id: ce.detail.chatId, num };
      setAiChatTabs(prev => [...prev, newTab]);
      setActiveAiTabId(ce.detail.chatId);
      lastAiChatIdRef.current = ce.detail.chatId;
      // GNB(홈 탭)는 변경하지 않음 — activeTab은 'home' 유지
    };
    window.addEventListener('navNewAiChat', handler as EventListener);
    return () => window.removeEventListener('navNewAiChat', handler as EventListener);
  }, []);

  /* 기존 navAddAiTab 이벤트 호환 (MOU 패널 버튼 등에서 발생) */
  useEffect(() => {
    const handler = () => {
      // navAddAiTab 이벤트는 무시 — 새 AI 탭은 navNewAiChat으로만 생성
    };
    window.addEventListener('navAddAiTab', handler);
    return () => window.removeEventListener('navAddAiTab', handler);
  }, []);

  function handleTabClick(id: string) {
    setActiveAiTabId(null);
    if (id === 'home') {
      // 홈 탭 클릭은 navGoHome이 Home 쪽에서 세션을 저장하고 idle 화면으로
      // 명시적으로 리셋하므로, 더 이상 이어서 볼 AI 채팅이 없다는 뜻이 된다.
      lastAiChatIdRef.current = null;
      window.dispatchEvent(new Event('navGoHome'));
      if (pathname !== '/') navigate('/');
    } else {
      // 다른 모듈(게시판/메일/메신저 등)로 이동 — lastAiChatIdRef는 그대로 둔다.
      // Home은 KeepAlive로 언마운트되지 않으므로 현재 AI 채팅의 대화 state는
      // 그대로 메모리에 살아있고, 나중에 이 탭으로 되돌아왔을 때 정확히
      // 어떤 채팅이 살아있었는지 알아야 잘못된 저장/복원(리셋)을 막을 수 있다.
      navigate(getTabPath(id));
    }
  }

  function handleTabClose(e: React.MouseEvent, id: string) {
    e.stopPropagation();
    if (id === 'home') return;
    const newTabs = openTabs.filter(t => t !== id);
    setOpenTabs(newTabs);
    if (activeTab === id) {
      const fallback = newTabs[newTabs.length - 1] || 'home';
      navigate(getTabPath(fallback));
    }
  }

  function handleAiTabClick(tabId: string) {
    // activeAiTabId가 아니라 lastAiChatIdRef를 사용한다: 다른 모듈 탭을 거쳐온 경우
    // activeAiTabId는 이미 null로 초기화되어 있어, 실제로 Home에 살아있던 이전
    // 채팅 id를 놓치면 그 채팅의 최신 대화가 저장되지 않고 유실될 수 있다.
    const prev = lastAiChatIdRef.current;
    setActiveAiTabId(tabId);
    lastAiChatIdRef.current = tabId;
    // Home에 세션 전환 알림 (저장 + 복원)
    window.dispatchEvent(new CustomEvent('navSwitchAiChat', {
      detail: { newChatId: tabId, prevChatId: prev },
    }));
    // 홈 경로 유지 (GNB 변경 없음)
    if (pathname !== '/') navigate('/');
  }

  function handleAiTabClose(e: React.MouseEvent, tabId: string) {
    e.stopPropagation();
    const newTabs = aiChatTabs.filter(t => t.id !== tabId);
    setAiChatTabs(newTabs);
    if (activeAiTabId === tabId) {
      if (newTabs.length > 0) {
        const last = newTabs[newTabs.length - 1];
        setActiveAiTabId(last.id);
        lastAiChatIdRef.current = last.id;
        // 남은 마지막 탭으로 전환 — Home의 activeChatId도 함께 갱신되도록 알린다.
        window.dispatchEvent(new CustomEvent('navSwitchAiChat', {
          detail: { newChatId: last.id, prevChatId: tabId },
        }));
      } else {
        setActiveAiTabId(null);
        lastAiChatIdRef.current = null;
        // 남은 AI 탭이 없음 — Home의 activeChatId 추적값을 초기화하지 않으면
        // 다음 ProActive 카드 클릭 시 이미 "활성 채팅이 있다"고 오판해 새 탭이
        // 생성되지 않는다 (닫힌 탭에 대응하는 채팅이 계속 추적되는 문제).
        window.dispatchEvent(new Event('navGoHome'));
      }
    } else if (lastAiChatIdRef.current === tabId) {
      // 닫힌 탭이 시각적으로는 비활성(다른 모듈 탭 표시 중)이었지만
      // Home에는 여전히 살아있던 채팅이었던 경우도 추적 값을 정리한다.
      lastAiChatIdRef.current = null;
      window.dispatchEvent(new Event('navGoHome'));
    }
  }

  return (
    <header className={styles.header}>

      {/* ── 로고 ── */}
      <div className={styles.headerLogo} onClick={() => window.location.reload()} style={{ cursor: 'pointer' }}>
        <div className={styles.logoMark}>
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
            <rect x="1"  y="1"  width="9" height="9" rx="2" fill="white" fillOpacity=".9"/>
            <rect x="12" y="1"  width="9" height="9" rx="2" fill="white" fillOpacity=".6"/>
            <rect x="1"  y="12" width="9" height="9" rx="2" fill="white" fillOpacity=".6"/>
            <rect x="12" y="12" width="9" height="9" rx="2" fill="white" fillOpacity=".3"/>
          </svg>
        </div>
        <span className={styles.logoText}>
          <span className={styles.logoMain}>Enterprise AI</span>
          <span className={styles.logoSub}>Platform</span>
        </span>
      </div>

      {/* ── 센터: 네비 탭 ── */}
      <div className={styles.headerCenter}>
        <div className={styles.navTabs}>

          {/* 일반 탭 (홈, 메신저, 등) */}
          {openTabs.flatMap((tabId, i) => {
            const tab = TAB_DEFS.find(t => t.id === tabId);
            if (!tab) return [];
            const isActive = tabId === activeTab && !activeAiTabId;
            const isHome   = tabId === 'home';
            const items: React.ReactNode[] = [];

            if (i > 0) {
              items.push(<div key={`div-${tabId}`} className={styles.navTabsDivider} />);
            }
            items.push(
              <button
                key={tabId}
                className={`${styles.navTab}${isActive ? ` ${styles.navTabActive}` : ''}`}
                onClick={() => handleTabClick(tabId)}
              >
                <span className={styles.navTabIcon}>{tab.icon}</span>
                <span className={styles.navTabLabel}>{t(tab.labelKey)}</span>
                {!isHome && (
                  <span
                    className={styles.navTabClose}
                    onClick={(e) => handleTabClose(e, tabId)}
                    title={t('nav.closeTab')}
                  >×</span>
                )}
              </button>
            );
            return items;
          })}

          {/* AI 대화 탭들 */}
          {aiChatTabs.map((aiTab) => {
            const isActive = aiTab.id === activeAiTabId;
            return (
              <span key={aiTab.id} style={{ display: 'contents' }}>
                <div className={styles.navTabsDivider} />
                <button
                  className={`${styles.navTab} ${styles.aiChatTab} ${isActive ? styles.aiChatTabActive : ''}`}
                  onClick={() => handleAiTabClick(aiTab.id)}
                >
                  <span className={styles.navTabIcon}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z"/>
                    </svg>
                  </span>
                  <span className={styles.navTabLabel}>{t('nav.aiChatTab', { num: aiTab.num })}</span>
                  <span
                    className={styles.navTabClose}
                    onClick={(e) => handleAiTabClose(e, aiTab.id)}
                    title={t('nav.closeTab')}
                  >×</span>
                </button>
              </span>
            );
          })}

        </div>
      </div>

      {/* ── 우측 컨트롤 ── */}
      <div className={styles.headerRight}>

        {/* ── 기본 상태: 벨(점) + 언어 + 아바타 ── */}
        <div className={styles.headerAvatarDefault}>

          {/* 알림 벨 — 숫자 없이 점(dot)만 */}
          <button className={styles.iconBtn} title={t('top.notifications')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
            </svg>
            <span className={styles.notifDot} />
          </button>

          {/* 포털 전환 — 홈 화면을 기본/세리사무소 두 벌 중에 고른다.
              선택은 localStorage 에 남아 새로고침해도 유지된다(lib/portal.ts). */}
          <button
            type="button"
            className={`${styles.portalBtn} ${portal === 'zeirishi' ? styles.portalBtnOn : ''}`}
            onClick={() => setPortal(portal === 'zeirishi' ? 'default' : 'zeirishi')}
            title={t('top.portalToggle', { portal: portalLabel })}
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="7" height="18" rx="1.5"/>
              <rect x="14" y="3" width="7" height="18" rx="1.5"/>
            </svg>
            <span>{portalLabel}</span>
          </button>

          {/* 언어 변경 — KRDS 드롭다운 유형 (LanguageSwitcher.tsx). 페이지 로딩 시 ?lang= 로도 지정된다 */}
          <LanguageSwitcher />

          {/* 아바타 + chevron (이름 없음) → 클릭 시 프로필 드롭다운 */}
          <div className={styles.avatarMenuRoot} ref={menuRef}>
            <button
              type="button"
              className={styles.avatarWrap}
              onClick={() => setMenuOpen(o => !o)}
              aria-haspopup="menu"
              aria-expanded={menuOpen}
            >
              <AXAvatar
                src={`${PUBLIC_URL}/assets/profiles/profile-kwak-myeongho.jpeg`}
                fallbackText={displayName}
                alt={displayName}
                size={34}
              />
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
                style={{ transform: menuOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.15s' }}>
                <path d="M6 9l6 6 6-6"/>
              </svg>
            </button>

            {menuOpen && (
              <div className={styles.avatarMenu} role="menu">
                <div className={styles.avatarMenuHeader}>
                  <AXAvatar
                    src={`${PUBLIC_URL}/assets/profiles/profile-kwak-myeongho.jpeg`}
                    fallbackText={displayName}
                    alt={displayName}
                    size={34}
                  />
                  <div className={styles.avatarMenuUser}>
                    <span className={styles.avatarMenuName}>{displayName}</span>
                    <span className={styles.avatarMenuPos}>{displayPosition}</span>
                  </div>
                </div>

                <div className={styles.avatarMenuDivider} />

                <button
                  type="button"
                  className={styles.avatarMenuItem}
                  role="menuitem"
                  onClick={() => { setMenuOpen(false); navigate('/settings'); }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="3"/>
                    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                  </svg>
                  {t('nav.settings')}
                </button>

                <div className={styles.avatarMenuDivider} />

                <button
                  type="button"
                  className={`${styles.avatarMenuItem} ${styles.avatarMenuItemDanger}`}
                  role="menuitem"
                  onClick={handleLogout}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                    <polyline points="16 17 21 12 16 7"/>
                    <line x1="21" y1="12" x2="9" y2="12"/>
                  </svg>
                  {t('top.logout')}
                </button>
              </div>
            )}
          </div>
        </div>

        {/* ── AI 응답 중 상태 (기본 숨김) ── */}
        <div className={styles.headerAvatarAi}>

          {/* 알림 벨 + 숫자 배지 */}
          <div className={styles.bellBadgeWrap}>
            <button className={styles.iconBtn} title={t('top.notifications')}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
              </svg>
            </button>
            <span className={styles.bellBadge}>3</span>
          </div>

          {/* 도움말 */}
          <button className={styles.helpBtn} title={t('nav.help')}>?</button>

          {/* 아바타 + 이름 + chevron */}
          <div className={styles.avatarWithName}>
            <AXAvatar
              src={`${PUBLIC_URL}/assets/profiles/profile-kwak-myeongho.jpeg`}
              fallbackText={displayName}
              alt={displayName}
              size={34}
            />
            <span className={styles.avatarName}>김민준</span>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 9l6 6 6-6"/>
            </svg>
          </div>
        </div>

      </div>

    </header>
  );
}
